/* eslint-disable prefer-destructuring */
import toasts from '../../core/toasts';

export const operations = toasts.operations;
export const selectors = toasts.selectors;
export default toasts;
